/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// const baseURL = this.mainBaseURL;

// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 重置
export function resetFiles(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].clearFiles();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange) {
	var search = params;
	search.beginTime = "";
	search.endTime = "";
	if (null != dateRange && '' != dateRange) {
		search.beginTime = this.dateRange[0];
		search.endTime = this.dateRange[1];
	}
	return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
	var actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key].dictCode == ('' + value)) {
			actions.push(datas[key].dictName);
			return true;
		}
	})
	return actions.join('');
}

// 通用下载方法
export function download(fileName) {
	window.location.href = this.mainBaseURL + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
}

// 字符串格式化(%s )
export function sprintf(str) {
	var args = arguments, flag = true, i = 1;
	str = str.replace(/%s/g, function () {
		var arg = args[i++];
		if (typeof arg === 'undefined') {
			flag = false;
			return '';
		}
		return arg;
	});
	return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
        return "";
    }
    return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
	id = id || 'id'
	parentId = parentId || 'parentId'
	children = children || 'children'
	rootId = rootId || 0
	//对源数据深度克隆
	const cloneData = JSON.parse(JSON.stringify(data))
	//循环所有项
	const treeData =  cloneData.filter(father => {
	  let branchArr = cloneData.filter(child => {
		//返回每一项的子级数组
		return father[id] === child[parentId]
	  });
	  branchArr.length > 0 ? father.children = branchArr : '';
	  //返回第一层
	  return father[parentId] === rootId;
	});
	return treeData != '' ? treeData : data;
  }


/**
 * 类型装换
 * @param data 数据源
 * @param val 比对值
 * @param dictLabel 返回节点
 */
export function applicationTypeData (data, val, dictLabel, dictValue) {
  dictLabel = dictLabel || 'dictLabel'
	dictValue = dictValue || 'dictValue'
  if(val !== undefined) {
    const cloneData = data.filter(father => {
      return father[dictValue] === val
    })
    return cloneData[0][dictLabel]
  }
}

/**
 * 根据地址下载
 * @param file
 */
export function handleView(file) {
  if(file.url !== undefined) {
    window.open(file.url,'_blank');
    return false;
  }

  if(file.response !== undefined && file.response.data.url !== undefined) {
    window.open(file.response.data.url,'_blank');
    return false;
  }
}


/**
 * 专精特新统一文件格式校验
 */
export function beforeUploadZjtx(file,fileList){
  let suffix=file.name.substring(file.name.lastIndexOf(".")+1);
  if (suffix!='pdf'&&suffix!='doc'&&suffix!='docx'){
    this.msgError("只能上传pdf/doc/docx格式的文件");
    return false;
  }
  if (file.size>10240000){
    this.msgError("文件最大可上传10MB,您上传的"+file.name+"已超出限制");
    return false;
  }
}



/**
 * 计算天数差的函数，通用
 * @param sDate1 开始
 * @param sDate2 截止
 * @returns {Number}天数
 */
 export function DateDiff(sDate1,  sDate2){ 
    let start = parseTime(sDate1, '{y}-{m}-{d}')
	let end = parseTime(sDate2, '{y}-{m}-{d}')

	let diff = Math.ceil((new Date(end)-new Date(start))/(60*60*24*1000))
	return diff > 0 ? diff : 0
}